import { Network } from '@capacitor/network';
import { NetworkInterface } from './network';

export class NetworkNative implements NetworkInterface {
  private _isOnline = true;
  private callbacks: ((isOnline: boolean) => void)[] = [];

  constructor() {
    (async () => {
      const { connected } = await Network.getStatus();
      this._isOnline = connected;
    })();

    Network.addListener(`networkStatusChange`, ({ connected }) => {
      if (connected === this._isOnline) {
        return;
      }

      this._isOnline = connected;

      this.callbacks.forEach((callback) => callback(connected));
    });
  }

  addCallback(callback: (isOnline: boolean) => void): void {
    this.callbacks.push(callback);
  }

  isOnline(): boolean {
    return this._isOnline;
  }

  removeListeners(): void {
    Network.removeAllListeners();
  }
}
